<template>
    <div
        class="course-form text-start pb-8 pb-14"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <Loader v-if="isLoading" />
        <v-container v-else class="p-0" fluid>
            <div class="page-card">
                <h1 class="card-title mb-2">
                    <span v-if="!isEditing">Novo</span>
                    <span v-else>Editar</span>
                    curso
                </h1>
                <p class="card-subtitle mb-4 mb-md-5">
                    <span v-if="!isEditing">Crie</span
                    ><span v-else>Edite</span> as informações básicas do seu
                    curso. Após salvar, você poderá personalizar e criar os
                    módulos e atividades.
                </p>
                <hr class="page-card__divider" />
                <v-row class="mt-2 mt-md-4">
                    <v-col cols="12" md="4">
                        <label for="nameInput" class="labeld required"
                            >Nome do curso</label
                        >
                        <input
                            id="nameInput"
                            type="text"
                            class="inputd"
                            v-model="courseData.name"
                            placeholder="Digite o nome do curso"
                            required
                        />
                    </v-col>

                    <v-col cols="12" md="4">
                        <label for="comercialNameInput" class="labeld required"
                            >Nome do comercial</label
                        >
                        <input
                            id="comercialNameInput"
                            type="text"
                            class="inputd"
                            v-model="courseData.commercialName"
                            placeholder="Digite o nome do comercial"
                            required
                        />
                    </v-col>

                    <v-col cols="12" md="4">
                        <label for="urlInput" class="labeld required"
                            >URL do curso</label
                        >
                        <input
                            id="urlInput"
                            type="text"
                            class="inputd"
                            v-model="courseData.url"
                            placeholder="Digite a URL do curso"
                            required
                        />
                    </v-col>

                    <v-col cols="6" md="3">
                        <label for="priceInput" class="labeld required"
                            >Preço</label
                        >
                        <div class="append-input-group">
                            <div class="append-input-group__text">R$</div>
                            <input
                                id="priceInput"
                                type="text"
                                class="inputd"
                                :value="
                                    courseData.price
                                        ? courseData.price
                                              .toString()
                                              .replace('.', ',')
                                        : ''
                                "
                                placeholder="0,00"
                                required
                                pattern="[0-9,]*"
                                inputmode="decimal"
                                @input="onChangeCurrency('price', $event)"
                            />
                        </div>
                    </v-col>

                    <v-col cols="6" md="3">
                        <label for="courseDiscountInput" class="labeld required"
                            >Desconto</label
                        >
                        <div class="append-input-group">
                            <div class="append-input-group__text">R$</div>
                            <input
                                id="courseDiscountInput"
                                type="text"
                                class="inputd"
                                :value="
                                    courseData.discount
                                        ? courseData.discount
                                              .toString()
                                              .replace('.', ',')
                                        : ''
                                "
                                placeholder="0,00"
                                required
                                pattern="[0-9,]*"
                                inputmode="decimal"
                                @input="onChangeCurrency('discount', $event)"
                            />
                        </div>
                    </v-col>

                    <v-col cols="6" md="3">
                        <label
                            for="courseFinalValueInput"
                            class="labeld required"
                            >Valor Final</label
                        >
                        <div class="append-input-group">
                            <div class="append-input-group__text">R$</div>
                            <input
                                id="courseFinalValueInput"
                                type="text"
                                class="inputd"
                                :value="
                                    (courseData.price - courseData.discount)
                                        .toFixed(2)
                                        .replace('.', ',')
                                "
                                placeholder="0,00"
                                readonly
                            />
                        </div>
                    </v-col>

                    <v-col cols="6" md="3">
                        <label for="installment" class="labeld"
                            >Número de parcelas</label
                        >
                        <select
                            name=""
                            id="installment"
                            class="form-select inputd"
                            v-model="courseData.installment"
                        >
                            <option v-for="n in 12" :key="n" :value="n">
                                {{ n }}
                            </option>
                        </select>
                    </v-col>

                    <v-col cols="12" md="6">
                        <label class="labeld" for="shortDescriptionTextarea"
                            >Descrição</label
                        >
                        <textarea
                            id="shortDescriptionTextarea"
                            class="inputd"
                            v-model="courseData.shortDescription"
                            placeholder="Adicione informações e detalhes sobre o curso"
                            rows="4"
                        ></textarea>
                    </v-col>

                    <v-col cols="12" md="6">
                        <label
                            class="labeld"
                            for="courseCompleteDescriptionTextarea"
                            >Descrição Completa</label
                        >
                        <textarea
                            id="courseCompleteDescriptionTextarea"
                            class="inputd"
                            v-model="courseData.longDescription"
                            placeholder="Adicione uma descrição completa sobre o curso"
                            rows="4"
                        ></textarea>
                    </v-col>

                    <v-col cols="12" md="4">
                        <div
                            class="flex align-items-center justify-content-between mb-2"
                        >
                            <label for="approvalEnabledToggle" class="labeld"
                                >Habilitar aprovação com nota?</label
                            >
                            <CustomToggle
                                :id="'approvalEnabledToggle'"
                                v-model="courseData.approvalEnabled"
                            />
                        </div>
                        <div>
                            <label for="courseMinGradeSelect" class="labeld"
                                >Nota mínima</label
                            >
                            <select
                                name=""
                                id="courseMinGradeSelect"
                                class="form-select inputd"
                                v-model="courseData.minGrade"
                                :disabled="!courseData.approvalEnabled"
                            >
                                <option disabled value="0">0</option>
                                <option v-for="n in 20" :key="n" :value="n / 2">
                                    {{ n / 2 }}
                                </option>
                            </select>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4" class="px-md-6">
                        <div
                            class="flex align-items-center justify-content-between mb-2"
                        >
                            <label for="certificateEnabledToggle" class="labeld"
                                >Possui certificado?</label
                            >
                            <CustomToggle
                                :id="'certificateEnabledToggle'"
                                v-model="courseData.certificateEnabled"
                            />
                        </div>

                        <div>
                            <label for="statusSelect" class="labeld required"
                                >Status</label
                            >
                            <select
                                id="statusSelect"
                                class="form-select inputd"
                                v-model="courseData.status"
                                required
                            >
                                <option value="1">Ativo</option>
                                <option value="2">
                                    Apenas matrículas internas
                                </option>
                                <option value="3">Em Espera</option>
                                <option value="4">Inativo</option>
                            </select>
                        </div>
                    </v-col>

                    <v-col
                        cols="12"
                        md="4"
                        class="d-md-flex flex-md-column justify-content-md-end"
                    >
                        <label
                            for="courseAvaliabilityDeadlineSelect"
                            class="labeld required"
                        >
                            Prazo para Disponibilidade
                        </label>

                        <select
                            id="courseAvaliabilityDeadlineSelect"
                            class="form-select inputd"
                            v-model="courseData.availabilityDeadline"
                            required
                        >
                            <option value="1">1 dia</option>
                            <option value="2">2 dias</option>
                            <option value="3">3 dias</option>
                            <option value="4">4 dias</option>
                            <option value="5">5 dias</option>
                            <option value="6">6 dias</option>
                            <option value="7">7 dias</option>
                            <option value="8">8 dias</option>
                            <option value="9">9 dias</option>
                            <option value="10">10 dias</option>
                            <option value="20">20 dias</option>
                            <option value="30">30 dias</option>
                            <option value="40">40 dias</option>
                            <option value="50">50 dias</option>
                            <option value="60">60 dias</option>
                            <option value="70">70 dias</option>
                            <option value="80">80 dias</option>
                            <option value="90">90 dias</option>
                            <option value="120">4 meses</option>
                            <option value="150">5 meses</option>
                            <option value="180">6 meses</option>
                            <option value="210">7 meses</option>
                            <option value="240">8 meses</option>
                            <option value="270">9 meses</option>
                            <option value="300">10 meses</option>
                            <option value="330">11 meses</option>
                            <option value="365">12 meses</option>
                            <option value="0">Vitalício</option>
                        </select>
                    </v-col>

                    <v-col cols="12" md="6">
                        <label
                            for="courseCoverImageSelect"
                            class="labeld required"
                            >Capa do Produto - Principal</label
                        >
                        <CustomFileInput
                            id="courseCoverImageSelect"
                            v-model="coverImage.file"
                            height="160"
                            :can-delete="false"
                            infoText="Selecione uma imagem no formato JPG ou PNG"
                        />
                        <p class="helper-text mt-1">
                            Tamanho recomendado: 800x800 pixels (proporção 1:1)
                        </p>
                    </v-col>

                    <v-col cols="12" md="6">
                        <label
                            for="courseThumbnailSelect"
                            class="labeld required"
                            >Capa do Produto - Thumbnail</label
                        >
                        <CustomFileInput
                            id="courseThumbnailSelect"
                            v-model="thumbnailImage.file"
                            height="160"
                            :can-delete="false"
                            infoText="Selecione uma imagem no formato JPG ou PNG"
                        />
                        <p class="helper-text mt-1">
                            Tamanho recomendado: 1440x768 pixels (proporção
                            16:9)
                        </p>
                    </v-col>

                    <v-col
                        cols="12"
                        class="d-flex justify-content-center justify-content-md-end mt-5 mt-md-6"
                    >
                        <v-btn
                            variant="tonal"
                            color="grey-light-4"
                            :size="$vuetify.display.xs ? 'default' : 'large'"
                            class="mr-4"
                            @click="$router.go(-1)"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn
                            variant="flat"
                            color="primary"
                            :size="$vuetify.display.xs ? 'default' : 'large'"
                            :min-width="$vuetify.display.xs ? '120px' : '140px'"
                            @click="saveCourse"
                        >
                            Salvar
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import apiAWS from '@/utils/storage/aws';
    import apiCourses from '@/utils/courses';
    import { toast } from 'vue3-toastify';
    import CustomToggle from '@/components/Form/CustomToggle.vue';
    import CustomFileInput from '@/components/Form/CustomFileInput.vue';
    import Loader from '@/components/Weflix/Loader';

    export default {
        components: {
            CustomToggle,
            CustomFileInput,
            Loader,
        },
        data() {
            return {
                isLoading: false,
                courseData: {
                    name: '',
                    commercialName: '',
                    url: '',
                    status: '1',
                    price: null,
                    discount: 0,
                    shortDescription: '',
                    longDescription: '',
                    approvalEnabled: false,
                    minGrade: 0,
                    certificateEnabled: false,
                    availabilityDeadline: 1,
                    coverImage: null,
                    thumbnailImage: null,
                    installment: 1,
                },
                coverImage: {
                    file: null,
                    path: '',
                    finalPath: '',
                },
                thumbnailImage: {
                    file: null,
                    path: '',
                    finalPath: '',
                },
            };
        },
        watch: {
            'courseData.name'(newVal, oldVal) {
                const commercial = this.courseData.commercialName;
                if (!commercial || commercial === oldVal) {
                    this.courseData.commercialName = newVal;
                }
                this.courseData.url = this.formatUrl(newVal);
            },
            'courseData.approvalEnabled'(newVal) {
                if (!newVal) {
                    this.courseData.minGrade = 0;
                }
            },
        },
        computed: {
            ...mapState(['token']),
            isEditing() {
                return !!this.$route.params.id;
            },
            courseId() {
                return this.$route.params.id || null;
            },
        },
        beforeMount() {
            if (this.isEditing) {
                this.getCourseData();
            }
        },
        methods: {
            ...mapActions(['storeCurrentCollections']),
            async getCourseData() {
                this.isLoading = true;
                try {
                    if (this.courseId) {
                        const response = await apiCourses.getCourse(
                            this.courseId,
                            this.token
                        );

                        this.courseData.name = response.name || '';
                        this.courseData.commercialName =
                            response.comercialName || '';
                        this.courseData.url = response.url || '';
                        this.courseData.status = response.status
                            ? response.status.toString()
                            : '1';
                        this.courseData.price =
                            response.price != null
                                ? this.formatCurrency(response.price * 100)
                                : null;
                        this.courseData.discount =
                            response.discount != null
                                ? this.formatCurrency(response.discount * 100)
                                : 0;
                        this.courseData.shortDescription =
                            response.shortDescription || '';
                        this.courseData.longDescription =
                            response.longDescription || '';
                        this.courseData.approvalEnabled = !!response.approved;
                        this.courseData.minGrade = response.approved || 0;
                        this.courseData.certificateEnabled =
                            !!response.certificate;
                        this.courseData.availabilityDeadline =
                            response.dayExpired || 0;

                        // Images
                        this.coverImage.path = response.imagePath || '';
                        this.coverImage.finalPath =
                            response.imageFinalPath || '';
                        this.coverImage.file = response.imageFinalPath || null;

                        this.thumbnailImage.path = response.imagePath2 || '';
                        this.thumbnailImage.finalPath =
                            response.imageFinalPath2 || '';
                        this.thumbnailImage.file =
                            response.imageFinalPath2 || null;
                    }
                } catch (error) {
                    // console.error(error)
                    this.$router.push({
                        path: '/dashboard/cursos',
                    });
                    this.notify('Erro ao carregar os dados do curso.', 'error');
                } finally {
                    this.isLoading = false;
                }
            },
            onChangeCurrency(field, event) {
                const value = event.target.value.replace(/\D/g, '');
                this.courseData[field] = this.formatCurrency(value);
            },
            formatCurrency(value) {
                const formmatedValue = (Number(value) / 100).toFixed(2);
                return formmatedValue;
            },
            formatUrl(value) {
                const formattedUrl = value
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .replace(/ç/g, 'c')
                    .replace(/[^a-z0-9\s]/g, '')
                    .replace(/\s+/g, '-')
                    .trim();

                return formattedUrl;
            },
            validateRequiredFields() {
                const requiredFields = [
                    { key: 'name', label: 'Nome do curso' },
                    { key: 'commercialName', label: 'Nome do comercial' },
                    { key: 'url', label: 'URL do curso' },
                    { key: 'status', label: 'Status' },
                    { key: 'price', label: 'Preço' },
                    { key: 'discount', label: 'Desconto' },
                    {
                        key: 'availabilityDeadline',
                        label: 'Prazo para Disponibilidade',
                    },
                ];
                for (const field of requiredFields) {
                    if (
                        this.courseData[field.key] === null ||
                        this.courseData[field.key] === '' ||
                        typeof this.courseData[field.key] === 'undefined'
                    ) {
                        this.notify(
                            `Preencha o campo obrigatório: ${field.label}`,
                            'error'
                        );
                        return false;
                    }
                }

                if (!this.coverImage.file) {
                    this.notify(
                        'Preencha o campo obrigatório: Capa do Produto - Principal',
                        'error'
                    );
                    return false;
                }

                if (!this.thumbnailImage.file) {
                    this.notify(
                        'Preencha o campo obrigatório: Capa do Produto - Thumbnail',
                        'error'
                    );
                    return false;
                }

                return true;
            },

            async saveCourse() {
                if (!this.validateRequiredFields()) return;

                this.isLoading = true;

                try {
                    await this.saveImages();

                    const payload = {
                        name: this.courseData.name,
                        comercialName: this.courseData.commercialName,
                        url: this.courseData.url,
                        status: this.courseData.status,
                        price: this.courseData.price,
                        discount: this.courseData.discount,
                        shortDescription: this.courseData.shortDescription,
                        longDescription: this.courseData.longDescription,
                        certificate: this.courseData.certificateEnabled ? 1 : 0,
                        imagePath: this.coverImage.path,
                        imagePath2: this.thumbnailImage.path,
                        dayExpired: this.courseData.availabilityDeadline,
                        approved: this.courseData.approvalEnabled
                            ? this.courseData.minGrade
                            : -1,
                        installment: this.courseData.installment,
                        order: 0,
                    };

                    let response;
                    if (this.isEditing) {
                        response = await apiCourses.editCourse(
                            this.courseId,
                            payload,
                            this.token
                        );
                    } else {
                        response = await apiCourses.createNewCourse(
                            payload,
                            this.token
                        );
                    }

                    this.storeCurrentCollections({
                        currentCollections: response,
                    });
                    this.$router.push({
                        path: '/dashboard/curso',
                        query: { toast: 'Curso criado com sucesso!' },
                    });
                } catch (error) {
                    console.error('Erro ao salvar curso:', error);
                    this.notify('Erro ao tentar salvar o curso', 'error');
                } finally {
                    this.isLoading = false;
                }
            },
            async saveImages() {
                //Se não for uma instância de arquivo, então não existe ou é uma string com o finalPath, nesse caso não precisa ser atualizado
                if (
                    this.coverImage.file &&
                    this.coverImage.file instanceof File
                ) {
                    this.coverImage.path = await this.saveImageAws(
                        this.coverImage.file
                    );
                }

                if (
                    this.thumbnailImage.file &&
                    this.thumbnailImage.file instanceof File
                ) {
                    this.thumbnailImage.path = await this.saveImageAws(
                        this.thumbnailImage.file
                    );
                }
            },
            async saveImageAws(file) {
                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    await this.putFileAws(response.url, file);
                    return response.token;
                } catch (error) {
                    this.notify('Erro ao gerar token da imagem.', 'error');
                }
            },
            async putFileAws(url, file) {
                try {
                    const response = await apiAWS.putFileAWS(url, file);
                    return response;
                } catch (error) {
                    this.notify('Erro ao salvar a imagem.', 'error');
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
    };
</script>
